import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FaCaretUp, FaCaretDown, FaPencilAlt, FaTrashAlt, FaRegClone } from 'react-icons/fa';
import FormattedListValue from '@/shared/components/FormattedListValue';
import { FormattedMessage } from 'react-intl';
import { CanUpdate, CanDelete } from '@/shared/components/security';
import Checkbox from '@/shared/components/input/Checkbox';
import messages from './workflowConfigurationMessages';

const WorkflowConfigurationTable = ({
  configurations,
  onEdit,
  onDelete,
  onCopy,
  taskTemplates,
  intl,
  isEmailAction,
  deleting,
}) => (
  <table className="table table-grid table-hover table-fixed">
    <thead>
      <tr>
        {isEmailAction ? (
          <th title={intl.formatMessage(messages.Name)}>
            <FormattedMessage {...messages.Name} />
          </th>
        ) : (
          <th title={intl.formatMessage(messages.Document)}>
            <FormattedMessage {...messages.Document} />
          </th>
        )}
        <th title={intl.formatMessage(messages.Task)}>
          <FormattedMessage {...messages.Task} />
        </th>
        <th title={intl.formatMessage(messages.Subtask)}>
          <FormattedMessage {...messages.Subtask} />
        </th>
        {!isEmailAction && (
          <th title={intl.formatMessage(messages.RequireDocumentSigned)}>
            <FormattedMessage {...messages.RequireDocumentSigned} />
          </th>
        )}
        <th title={intl.formatMessage(messages.MarkAsBlocked)}>
          <FormattedMessage {...messages.MarkAsBlocked} />
        </th>
        <th title={intl.formatMessage(messages.MarkAsInapplicable)}>
          <FormattedMessage {...messages.MarkAsInapplicable} />
        </th>
        <th title={intl.formatMessage(messages.TaskStatus)}>
          <FormattedMessage {...messages.TaskStatus} />
        </th>
        {!isEmailAction && (
          <th title={intl.formatMessage(messages.DaysBefore)}>
            <FormattedMessage {...messages.DaysBefore} />
          </th>
        )}
        {!isEmailAction && (
          <th title={intl.formatMessage(messages.DaysAfter)}>
            <FormattedMessage {...messages.DaysAfter} />
          </th>
        )}
        <th title={intl.formatMessage(messages.Actions)} className="text-right">
          <FormattedMessage {...messages.Actions} />
        </th>
      </tr>
    </thead>
    {configurations &&
      configurations.map(configuration => (
        <tbody key={configuration.id}>
          <tr>
            <td>
              <label>
                {isEmailAction ? (
                  configuration.name
                ) : (
                  <FormattedListValue list="workflowType" id={configuration.workflowType} />
                )}
              </label>
            </td>
            <td>
              <label>
                {taskTemplates[configuration.mainTaskTemplateId] ?? (
                  <i
                    className="fa fa-exclamation-triangle fa-fw text-danger"
                    title={intl.formatMessage(messages.TaskTemplateNotFoundProbablyDeleted)}
                  />
                )}
              </label>
            </td>
            <td>
              {configuration.subTaskTemplateId && (
                <label>
                  {taskTemplates[configuration.subTaskTemplateId] ?? (
                    <i
                      className="fa fa-exclamation-triangle fa-fw text-danger"
                      title={intl.formatMessage(messages.TaskTemplateNotFoundProbablyDeleted)}
                    />
                  )}
                </label>
              )}
            </td>
            {!isEmailAction && (
              <td>
                <label>
                  <Checkbox disabled value={configuration.requireDocumentSigned} />
                </label>
              </td>
            )}
            <td>
              <label>
                <Checkbox disabled value={configuration.markAsBlocked} />
              </label>
            </td>
            <td>
              <label>
                <Checkbox disabled value={configuration.markAsInapplicable} />
              </label>
            </td>
            <td>
              <label>
                {configuration.workflowType !== 3 && configuration.workflowType !== 144 ? (
                  configuration.desiredStatus === null ? (
                    <FormattedMessage {...messages.DontChangeStatus} />
                  ) : (
                    <FormattedListValue list="taskStatus" id={configuration.desiredStatus} />
                  )
                ) : null}
              </label>
            </td>
            {!isEmailAction && (
              <td>
                {configuration.workflowType !== 58 && (
                  <label>{configuration.toleranceDaysBefore}</label>
                )}
              </td>
            )}
            {!isEmailAction && (
              <td>
                {configuration.workflowType !== 58 && (
                  <label>{configuration.toleranceDaysAfter}</label>
                )}
              </td>
            )}
            <td className="text-right">
              <div className="flex-row-nowrap">
                <a className="btn btn-xs btn-icon" onClick={() => onEdit(configuration)}>
                  <FaPencilAlt className="fa-fw" />
                </a>
                <CanDelete on="Settings">
                  <a
                    className="btn btn-xs btn-icon"
                    disabled={deleting}
                    onClick={() => onDelete(configuration)}
                  >
                    {deleting && <i className="fa fa-spin fa-spinner" />}
                    {!deleting && <FaTrashAlt className="fa-fw" />}
                  </a>
                </CanDelete>
              </div>
            </td>
          </tr>
        </tbody>
      ))}
  </table>
);

export default WorkflowConfigurationTable;
